<script setup>
import DigiQ from "@/assets/images/educationAndTraning/DigiQ.png";
</script>

<template>
  <div class="space-y-2">
    <img :src="DigiQ" alt="" class="h-20 object-contain" />
    <div>
      <p>
        <a href="https://digiq.eu/" class="gradientText hoverUnderline">
          DigiQ: Digitally Enhanced Quantum Technology Master</a
        >
        is the flagship project in Higher Education, in which 16 newly
        developed/augmented Quantum Technology Master degrees will emerge across
        Europe. DigiQ will produce:
      </p>
      <ol class="list-disc px-6 pt-2">
        <li>
          30 innovative educational modules, openly accessible and available for
          all
        </li>
        <li>50+ specialist Master’s courses in QT</li>
        <li>4 year long Pan-European student networks</li>
        <li>
          a comprehensive mobility program placing students in top companies and
          research groups across Europe.
        </li>
      </ol>
    </div>
  </div>
</template>
